(function() {

  const check = document.querySelector('body.search');

  if( check ) {
    const search_controler = new ArchiveControler();
      search_controler.register_archive_container( document.getElementById('SearchContent') ); 
      search_controler.register_search_input( document.getElementById('Search') );
      search_controler.register_self_loading_classname('search__loading');
      search_controler.register_more_button_classname('button__more');
      search_controler.on('change', function( controller ) {
         // Add anchors
         document.querySelectorAll('.anchor').forEach(a => {
          a.addEventListener('click', e => {
            scrollToHash(a.getAttribute('href'), e);
          });
        });

        // Clean change param
        let cleanURL = window.location.origin + window.location.pathname;
        let search = document.getElementById('Search').value;
        if( search ) cleanURL = cleanURL + '?s=' + search;
        history.replaceState(null, '', cleanURL);

        // Change subquery
        document.getElementById('SearchQuery').innerHTML = search;
      });
  }

})();